import React from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { toast } from 'sonner';

const BuyerProfileModal = ({
  open, onOpenChange, profileForm, setProfileForm, user, t,
}) => {
  const saveProfile = async () => {
    try {
      await axios.put(`${API}/users/profile`, {
        name: profileForm.name, company: profileForm.company,
        company_info: { ...user?.company_info, company_name: profileForm.company, phone: profileForm.phone, company_email: profileForm.company_email, website: profileForm.website, street_address: profileForm.street_address, city: profileForm.city, state_province: profileForm.state_province, postal_code: profileForm.postal_code, country: profileForm.country },
        list_visible: profileForm.list_visible
      });
      toast.success('Profile updated successfully'); onOpenChange(false); window.location.reload();
    } catch (error) { toast.error(error.response?.data?.detail || 'Failed to update profile'); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t('dashboard.edit_your_profile')}</DialogTitle>
          <DialogDescription>{t('dashboard.update_info')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-6">
          <div>
            <h4 className="font-medium text-sm text-slate-700 mb-3">{t('dashboard.edit_your_profile')}</h4>
            <div className="grid grid-cols-2 gap-4">
              <div><Label>{t('dashboard.full_name')}</Label><Input value={profileForm.name} onChange={(e) => setProfileForm({ ...profileForm, name: e.target.value })} /></div>
              <div><Label>{t('dashboard.phone_label')}</Label><Input value={profileForm.phone} onChange={(e) => setProfileForm({ ...profileForm, phone: e.target.value })} /></div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-sm text-slate-700 mb-3">{t('dashboard.company_information')}</h4>
            <div className="grid grid-cols-2 gap-4">
              <div><Label>{t('dashboard.company_name')}</Label><Input value={profileForm.company} onChange={(e) => setProfileForm({ ...profileForm, company: e.target.value })} /></div>
              <div><Label>{t('dashboard.company_email_label')}</Label><Input type="email" value={profileForm.company_email} onChange={(e) => setProfileForm({ ...profileForm, company_email: e.target.value })} /></div>
              <div className="col-span-2"><Label>{t('dashboard.website_label')}</Label><Input value={profileForm.website} onChange={(e) => setProfileForm({ ...profileForm, website: e.target.value })} /></div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-sm text-slate-700 mb-3">{t('dashboard.street_address_label')}</h4>
            <div className="space-y-4">
              <div><Label>{t('dashboard.street_address_label')}</Label><Input value={profileForm.street_address} onChange={(e) => setProfileForm({ ...profileForm, street_address: e.target.value })} /></div>
              <div className="grid grid-cols-2 gap-4">
                <div><Label>{t('dashboard.city_label')}</Label><Input value={profileForm.city} onChange={(e) => setProfileForm({ ...profileForm, city: e.target.value })} /></div>
                <div><Label>{t('dashboard.state_province_label')}</Label><Input value={profileForm.state_province} onChange={(e) => setProfileForm({ ...profileForm, state_province: e.target.value })} /></div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div><Label>{t('dashboard.postal_code_label')}</Label><Input value={profileForm.postal_code} onChange={(e) => setProfileForm({ ...profileForm, postal_code: e.target.value })} /></div>
                <div><Label>{t('dashboard.country_label')}</Label><Input value={profileForm.country} onChange={(e) => setProfileForm({ ...profileForm, country: e.target.value })} /></div>
              </div>
            </div>
          </div>
          <div className="border-t pt-4 mt-4">
            <div className="flex items-start space-x-3">
              <Switch id="list_visible" checked={profileForm.list_visible} onCheckedChange={(checked) => setProfileForm({ ...profileForm, list_visible: checked })} />
              <div className="space-y-1">
                <Label htmlFor="list_visible" className="text-sm font-medium cursor-pointer">{t('dashboard.list_visible_label')}</Label>
                <p className="text-xs text-slate-500">{t('dashboard.list_visible_desc')}</p>
              </div>
            </div>
          </div>
          <div className="flex gap-2 pt-4 border-t">
            <Button variant="outline" className="flex-1" onClick={() => onOpenChange(false)}>{t('common.cancel')}</Button>
            <Button className="flex-1" onClick={saveProfile}>{t('dashboard.save_changes')}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BuyerProfileModal;
